// Real image URLs from user's existing site (kiplingsbundi.com)
// User will edit these as needed
export const IMG = {
  hero: "https://customer-assets-v7afamib.emergentagent.net/job_kipling-redesign-1/artifacts/10pqfiae_Haveli%20Braj%20Bhushanjee%2C%20Bundi_Interior.webp",
  heroAlt: "https://www.kiplingsbundi.com/img/V-2.jpg",
  aboutPortrait: "https://www.kiplingsbundi.com/img/P-13.jpg",
  aboutCourtyard: "https://www.kiplingsbundi.com/img/P-12.jpg",
  aboutMural: "https://www.kiplingsbundi.com/img/P-5.jpg",
  terraceView: "https://customer-assets-v7afamib.emergentagent.net/job_kipling-redesign-1/artifacts/1t02v22b_Haveli%20Braj%20Bhushanjee%2C%20Bundi_View%20of%20Palace.webp",
  interior1: "https://www.kiplingsbundi.com/img/V-9.jpg",
  interior2: "https://www.kiplingsbundi.com/img/V-11.jpg",
  interior3: "https://www.kiplingsbundi.com/img/V-21.jpg",
  restaurant: "https://customer-assets-v7afamib.emergentagent.net/job_kipling-redesign-1/artifacts/i97z9d3i_P-2.JPG",
};

export const ROOMS = [
  {
    id: "small",
    name: "Small Normal Room",
    price: 5500,
    size: "150 sq.ft",
    subtitle: "Garden / Courtyard facing",
    image: "https://www.kiplingsbundi.com/img/R-2.jpg",
    features: [
      "Air-conditioned (no heating)",
      "Private bathroom (attached) with separate shower space",
      "Tea / coffee maker",
      "Travel map & information",
      "Breakfast extra",
    ],
    extraPerson: 1750,
  },
  {
    id: "standard",
    name: "Standard Room",
    price: 9000,
    size: "200 sq.ft",
    subtitle: "Garden facing rooms",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_kipling-redesign-1/artifacts/aubekeak_R-10-1.jpg",
    features: [
      "Air Conditioned (with heating)",
      "Private bathroom (attached) with separate shower space",
      "Running hot and cold water",
      "Hair dryer",
      "Tea / coffee making facility",
      "Wi-Fi connectivity",
      "Bed side library",
      "Writing table in each room",
      "Open space / veranda with each room",
    ],
    extraPerson: 2750,
  },
  {
    id: "deluxe",
    name: "Deluxe Room",
    price: 11500,
    size: "250 sq.ft",
    subtitle: "Garden facing rooms",
    image: "https://customer-assets-v7afamib.emergentagent.net/job_kipling-redesign-1/artifacts/ryv021ia_R-B-7-2.jpg",
    features: [
      "Air Conditioned (with heating)",
      "Private bathroom (attached) with separate shower space",
      "Running hot and cold water",
      "Hair dryer",
      "Tea / coffee making facility",
      "Wi-Fi connectivity",
      "Bed side library",
      "Writing table in each room",
      "Open space / veranda with each room",
    ],
    extraPerson: 2750,
  },
];

export const TESTIMONIALS = [
  { name: "Isabelle Frossard", place: "France", quote: "The wonderful and friendly moment we spent in Bundi — still in mind." },
  { name: "Sonja Müller Lang", place: "Switzerland", quote: "A lovely stay at your haveli. We are promoting your place." },
  { name: "Eva & Wolfgang Lusak", place: "Austria", quote: "The most outstanding hotel in Bundi. Rooms decorated in the most romantic way." },
  { name: "Gita Kumar", place: "India", quote: "Warm hospitality. We recommend your haveli to future travellers." },
  { name: "Lander & Daisy Davidson", place: "UK", quote: "Haveli is simply spectacular — kind, lovely and helpful family." },
  { name: "Hans & Haile Fürer", place: "Switzerland", quote: "Marvellous view to the palace. Especially nice and cosy rooms." },
];

export const GALLERY = [
  // Views & terraces
  "https://www.kiplingsbundi.com/img/V-1.jpg",
  "https://www.kiplingsbundi.com/img/V-2.jpg",
  "https://www.kiplingsbundi.com/img/V-5.jpg",
  "https://www.kiplingsbundi.com/img/V-6.jpg",
  "https://www.kiplingsbundi.com/img/V-7.jpg",
  "https://www.kiplingsbundi.com/img/V-8.jpg",
  "https://www.kiplingsbundi.com/img/V-9.jpg",
  "https://www.kiplingsbundi.com/img/V-10.jpg",
  "https://www.kiplingsbundi.com/img/V-11.jpg",
  "https://www.kiplingsbundi.com/img/V-13.jpg",
  "https://www.kiplingsbundi.com/img/V-16.jpg",
  "https://www.kiplingsbundi.com/img/V-19.jpg",
  "https://www.kiplingsbundi.com/img/V-20.jpg",
  "https://www.kiplingsbundi.com/img/V-20.jpeg",
  "https://www.kiplingsbundi.com/img/V-21.jpg",
  "https://www.kiplingsbundi.com/img/V-22.jpg",
  "https://www.kiplingsbundi.com/img/V-24.jpg",
  "https://www.kiplingsbundi.com/img/V-25.jpg",
  "https://www.kiplingsbundi.com/img/V-26.jpg",

  // Painted courtyards, interiors, murals
  "https://www.kiplingsbundi.com/img/P-1.jpg",
  "https://www.kiplingsbundi.com/img/P-2.jpg",
  "https://www.kiplingsbundi.com/img/P-3.jpg",
  "https://www.kiplingsbundi.com/img/P-4.jpg",
  "https://www.kiplingsbundi.com/img/P-5.jpg",
  "https://www.kiplingsbundi.com/img/P-6.jpg",
  "https://www.kiplingsbundi.com/img/P-7.jpg",
  "https://www.kiplingsbundi.com/img/P-8.jpg",
  "https://www.kiplingsbundi.com/img/P-11.jpg",
  "https://www.kiplingsbundi.com/img/P-12.jpg",
  "https://www.kiplingsbundi.com/img/P-13.jpg",
  "https://www.kiplingsbundi.com/img/P-15.jpg",
  "https://www.kiplingsbundi.com/img/P-16.jpg",
  "https://www.kiplingsbundi.com/img/P-17.jpg",
  "https://www.kiplingsbundi.com/img/P-18.jpg",
  "https://www.kiplingsbundi.com/img/P-19.jpg",
  "https://www.kiplingsbundi.com/img/P-20.jpg",
  "https://www.kiplingsbundi.com/img/P-21.jpg",
  "https://www.kiplingsbundi.com/img/P-22.jpg",
  "https://www.kiplingsbundi.com/img/P-23.jpg",
  "https://www.kiplingsbundi.com/img/P-24.jpg",
  "https://www.kiplingsbundi.com/img/P-25.jpg",
  "https://www.kiplingsbundi.com/img/P-26.jpg",
  "https://www.kiplingsbundi.com/img/P-29.jpg",
  "https://www.kiplingsbundi.com/img/P-30.jpg",
  "https://www.kiplingsbundi.com/img/P-31.jpg",

  // Rooms (garden-facing wing)
  "https://www.kiplingsbundi.com/img/R-1.jpg",
  "https://www.kiplingsbundi.com/img/R-2.jpg",
  "https://www.kiplingsbundi.com/img/R-4.jpg",
  "https://www.kiplingsbundi.com/img/R-6.jpg",
  "https://www.kiplingsbundi.com/img/R-7.jpg",
  "https://www.kiplingsbundi.com/img/R-7-1.jpg",
  "https://www.kiplingsbundi.com/img/R-9.jpg",
  "https://www.kiplingsbundi.com/img/R-9-2.jpg",
  "https://www.kiplingsbundi.com/img/R-9-3.jpg",
  "https://www.kiplingsbundi.com/img/R-10.jpg",
  "https://www.kiplingsbundi.com/img/R-10-1.jpg",
  "https://www.kiplingsbundi.com/img/R-11.jpg",
  "https://www.kiplingsbundi.com/img/R-11-2.jpg",
  "https://www.kiplingsbundi.com/img/R-12.jpg",
  "https://www.kiplingsbundi.com/img/R-14.jpg",
  "https://www.kiplingsbundi.com/img/R-14-2.jpg",
  "https://www.kiplingsbundi.com/img/R-15.jpg",
  "https://www.kiplingsbundi.com/img/R-15-2.jpg",

  // Rooms (bagh / heritage wing)
  "https://www.kiplingsbundi.com/img/R-B-1.jpg",
  "https://www.kiplingsbundi.com/img/R-B-1-2.jpg",
  "https://www.kiplingsbundi.com/img/R-B-3.jpg",
  "https://www.kiplingsbundi.com/img/R-B-5.jpg",
  "https://www.kiplingsbundi.com/img/R-B-7.jpg",
  "https://www.kiplingsbundi.com/img/R-B-7-1.jpg",
  "https://www.kiplingsbundi.com/img/R-B-7-2.jpg",

  // Restaurant / Darikhana
  "https://www.kiplingsbundi.com/img/RE-1.jpg",
  "https://www.kiplingsbundi.com/img/RE-2.jpg",
];

export const AMENITIES = [
  "24-hour front desk",
  "Free Wi-Fi throughout",
  "Rooftop palace view",
  "Traditional Darikhana dining",
  "Small in-house museum",
  "Bundi School painting tour",
  "Heritage walk map",
  "Travel assistance",
  "Shopping area",
  "Business centre",
  "Daily housekeeping",
];

export const CONTACT = {
  phone: "+91 9783355866",
  phone2: "+91 9783355865",
  email: "havelibb@gmail.com",
  address: "Below Palace, Opp. Ayurvedic Hospital, Bundi (Rajasthan), India",
  whatsapp: "919783355866",
};
